import { ref } from 'vue'

/**
 * Tooltip feature composable for chartjs components
 * @return {{tooltipOptions: {external: function(*): void, enabled: boolean}, tooltip: ToRef<{shown: boolean, title: string, rows: []}>}}
 */
export default function () {
  const tooltip = ref({
    shown: false,
    title: '',
    rows: [],
  })
  const tooltipOptions = {
    enabled: false,
    external: context => {
      if (!context.tooltip.dataPoints)
        return {
          shown: false,
          title: '',
          rows: [],
        }
      tooltip.value.shown = context.tooltip.opacity !== 0
      tooltip.value.title = context.tooltip.title[0]
      tooltip.value.rows = context.tooltip.dataPoints.map(p => {
        return {
          value: p.raw.value,
          label: p.raw.code,
          color: p.element.options.backgroundColor,
          borderColor: p.element.options.borderColor,
        }
      })
    },
  }
  return {
    tooltip,
    tooltipOptions,
  }
}
